import { Box, Typography, type TypographyProps } from '@mui/material';
import { getClientsLabelsFromClientGroup } from './helpers';
import type { ClientGroup } from './types';

export type ClientGroupNameProps = TypographyProps & {
  contacts: ClientGroup['contacts'];
};

export const ClientGroupName = ({
  contacts,
  ...props
}: ClientGroupNameProps) => {
  const clientLabels = getClientsLabelsFromClientGroup(contacts);

  return (
    <Typography {...props}>
      {clientLabels.map(({ id, label, secondaryLabel }, i) => (
        <span key={id}>
          {i > 0 && ', '}
          <Box component="span">{label}</Box>
          {secondaryLabel && (
            <Typography
              sx={{ color: 'text.secondary' }}
              component="span"
              variant="body2"
            >
              {` (${secondaryLabel})`}
            </Typography>
          )}
        </span>
      ))}
    </Typography>
  );
};
